/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/location';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "person": {
        "nested": {
          "online_store": {
            "nested": {
              "OnlineStoreOptions": {
                "fields": {
                  "shippingAddress": {
                    "type": ".squareup.common.location.GlobalAddress",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.person?.nested?.online_store?.nested?.OnlineStoreOptions) {
  $root.addJSON(jsonData);
}

/**
 * Fields relevant to information stored by Online Store about a person.
 *
 * SOURCE OnlineStoreOptions @ squareup/person/online_store.proto at 20:1
 */
export const OnlineStoreOptions = $root.lookupType('squareup.person.online_store.OnlineStoreOptions');
fixType(OnlineStoreOptions);
Builder.createAndAttachToType(OnlineStoreOptions);